export default "__VITE_ASSET__0c5f4e4e__"